export default __webpack_public_path__ + "ba6fea2a19bb4936ceb8316be3eb71f4.png";